import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { RequestService } from "services/RequestService";

function UpdateForm({ open, onClose, gt, onSuccess }) {
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    stId: "",
  });

  const [sts, setSts] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (gt) {
      setFormData({
        id: gt.id,
        name: gt.name,
        stId: gt.stId || "",
      });
    }
  }, [gt]);

  useEffect(() => {
    fetchSTs();
  }, []);

  const fetchSTs = async () => {
    try {
      const response = await RequestService.get("ST");
      if (response.data && !response.data.error) {
        setSts(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching STs:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when field is modified
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "اسم التوربين مطلوب";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedGt = {
      ...formData,
      stId: formData.stId || null, // Convert empty string to null
    };

    onSuccess(updatedGt);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>تعديل التوربين الغازي</DialogTitle>
      <DialogContent>
        <MDBox component="form" role="form" onSubmit={handleSubmit} mt={2}>
          <MDBox mb={3}>
            <TextField
              fullWidth
              label="اسم التوربين"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              InputProps={{ style: { height: '45px' } }}
            />
          </MDBox>
          <MDBox mb={3}>
            <FormControl fullWidth>
              <InputLabel>التوربين البخاري</InputLabel>
              <Select
                name="stId"
                value={formData.stId}
                onChange={handleChange}
                label="التوربين البخاري"
                sx={{ height: '45px' }}
              >
                <MenuItem value="">
                  <em>لا يوجد</em>
                </MenuItem>
                {sts.map((st) => (
                  <MenuItem key={st.id} value={st.id}>
                    {st.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        </MDBox>
      </DialogContent>
      <DialogActions sx={{ 
            padding: 2, 
            display: 'flex', 
            justifyContent: 'space-between',
            '& > button': {
              marginLeft: '8px',
              marginRight: '0px',
            }
          }}>
      <MDButton onClick={handleSubmit} color="info">
          حفظ
        </MDButton>
        <MDButton onClick={onClose} color="secondary">
          إلغاء
        </MDButton>
 
      </DialogActions>
    </Dialog>
  );
}

// PropTypes validation
UpdateForm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  gt: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    stId: PropTypes.string,
  }),
};

// Default props
UpdateForm.defaultProps = {
  gt: null,
};

export default UpdateForm;
